// services/cotacoes/cotacoes.service.ts

import { API } from "../api";
import type {
  CobrancaCotacao,
  GetCotacoesParams,
  GetCotacoesResponse,
  ResumoCotacoes,
} from "./cotacoes.types";

/**
 * Busca todas as cotações
 * GET /api/cotacoes
 */
export const getCotacoes = async (
  params?: GetCotacoesParams,
): Promise<GetCotacoesResponse> => {
  const { data } = await API.get<GetCotacoesResponse>("/api/cotacoes", {
    params,
  });

  return data;
};

/**
 * Contagem por status e soma de frete + desembaraço, para as abas e o
 * cabeçalho. Aceita os mesmos filtros da listagem, menos `status` — ele conta
 * todos os status justamente para desenhar as abas.
 * GET /api/cotacoes/resumo
 */
export const getResumoCotacoes = async (
  params?: Omit<GetCotacoesParams, "page" | "limit" | "status">,
): Promise<ResumoCotacoes> => {
  const { data } = await API.get<ResumoCotacoes>("/api/cotacoes/resumo", {
    params,
  });
  return data;
};

/**
 * Quanto custa a remessa, como se compõe e se já foi paga.
 * GET /api/cotacoes/:id/cobranca
 */
export const getCobrancaCotacao = async (
  id: number,
): Promise<CobrancaCotacao> => {
  const { data } = await API.get<CobrancaCotacao>(
    `/api/cotacoes/${id}/cobranca`,
  );
  return data;
};

/**
 * Agenda a coleta da remessa na transportadora.
 *
 * Só UPS: o handler recusa FedEx com 400 ("Agendamento de coleta disponível
 * apenas para UPS no momento"). Para FedEx o caminho continua sendo o modal
 * de coleta do menu.
 * POST /api/cotacoes/:id/pickup
 */
export const agendarColetaCotacao = async (
  id: number,
  payload: { pickupDate: string; readyTime?: string; closeTime?: string },
) => {
  const { data } = await API.post<{ ok: boolean; error?: string }>(
    `/api/cotacoes/${id}/pickup`,
    payload,
  );
  return data;
};

/**
 * Debita a remessa inteira da carteira.
 * POST /api/cotacoes/:id/pagar-com-saldo
 */
export const pagarCotacaoComSaldo = async (id: number) => {
  const { data } = await API.post<{
    ok: boolean;
    pago?: boolean;
    ja_pago?: boolean;
    cobrado_centavos?: number;
    saldo_centavos?: number;
  }>(`/api/cotacoes/${id}/pagar-com-saldo`);
  return data;
};
